import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DocumentTemplateDetails } from '../models/document-template-details';
import { DocumentTemplateManagementService } from './document-template-management.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentTemplateManagementInteractionService {
  documentTemplates$ = new BehaviorSubject<DocumentTemplateDetails[]>([]);
  removeScopeSelection$ = new BehaviorSubject<boolean>(false);
  constructor(private documentTemplateManagementService: DocumentTemplateManagementService) { }

  refreshDocumentTemplates = () => {
    this.documentTemplateManagementService.getDocumentTemplates().subscribe(documentTemplates => {
      this.documentTemplates$.next(documentTemplates);
    })
  }

  removeScopeSelection = () => {
    this.removeScopeSelection$.next(true);
  }
}
